import { useMemo } from 'react';
import { useTargetingContext } from '../../../utils/context/TargetingContext.tsx';

export const useContextualAccount = (accountUid: string) => {
  const { useRelatedAccountsFetch } = useTargetingContext();
  const { relatedAccounts, loading } = useRelatedAccountsFetch([]);
  const accountUidFromProps = accountUid || '';

  const providerIds = useMemo(() => {
    return Object.keys(relatedAccounts?.[accountUidFromProps]?.contextual_providers || {});
  }, [accountUidFromProps, relatedAccounts]);

  return {
    accountId: relatedAccounts?.[accountUidFromProps]?.id,
    loading,
    providerIds,
  };
};
